module.exports = __webpack_public_path__ + "img/gate_2_3.fcaf6583.png";